<router-outlet />
@if (errorHandler.lastError(); as msg) {
  <app-error-panel [message]="msg" (dismissed)="errorHandler.dismiss()" />
}
